import type { PropsWithChildren } from 'react';

import ToolCanvas from '../ToolCanvas';
import { useToolPcdCanvasContext } from './hook';

const ToolPcdCanvas = ({ children }: PropsWithChildren) => {
  const { enabledFullScreen } = useToolPcdCanvasContext();

  return (
    <>
      <ToolCanvas enabledFullScreen={enabledFullScreen}>
        <ambientLight intensity={0.5} />
        <directionalLight position={[5, 10, 5]} />

        {children}
      </ToolCanvas>
    </>
  );
};

export default ToolPcdCanvas;
